import { NEIGHBORHOOD_CENTERS } from "./geoDecisionEngine";

export const NEIGHBORHOOD_DETECTION_CONFIG = {
  MIN_ZOOM: 12,
  MAX_DISTANCE_DEGREES: 0.02,
  MAP_DEBOUNCE_MS: 300,
  MIN_CENTER_CHANGE_DEGREES: 0.001,
} as const;

export function hasMapCenterChangedSignificantly(
  previous: { lat: number; lng: number } | null,
  current: { lat: number; lng: number }
): boolean {
  if (!previous) {
    return true;
  }

  return (
    Math.abs(previous.lat - current.lat) >
      NEIGHBORHOOD_DETECTION_CONFIG.MIN_CENTER_CHANGE_DEGREES ||
    Math.abs(previous.lng - current.lng) >
      NEIGHBORHOOD_DETECTION_CONFIG.MIN_CENTER_CHANGE_DEGREES
  );
}

export function detectNeighborhoodFromMapCenter(
  center: { lat: number; lng: number },
  zoom: number
): string | null {
  if (zoom < NEIGHBORHOOD_DETECTION_CONFIG.MIN_ZOOM) {
    return null;
  }

  let closestNeighborhood: string | null = null;
  let closestDistance = Infinity;

  Object.entries(NEIGHBORHOOD_CENTERS).forEach(([name, coords]) => {
    const distance = Math.sqrt(
      (center.lat - coords.lat) ** 2 + (center.lng - coords.lng) ** 2
    );

    if (
      distance < closestDistance &&
      distance < NEIGHBORHOOD_DETECTION_CONFIG.MAX_DISTANCE_DEGREES
    ) {
      closestDistance = distance;
      closestNeighborhood = name;
    }
  });

  return closestNeighborhood;
}

export function buildNeighborhoodContextUrl(
  neighborhood: string | null,
  baseSearch: string
): string {
  const params = new URLSearchParams(baseSearch);

  params.delete("lat");
  params.delete("lng");
  params.delete("radius");
  params.delete("zoom");

  if (neighborhood) {
    params.set("neighborhood", neighborhood);
  } else {
    params.delete("neighborhood");
  }

  return `?${params.toString()}`;
}
